import React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { styled } from '@this/constants/themes';
import { AddCircleOutline as AddCircleOutlineIcon } from '@material-ui/icons';

interface Props {
  to: string;
  label: string;
}

const NewBigButton = observer(
  React.forwardRef<Link, Props>(({ to, label }, ref) => {
    return (
      <Button
        variant="contained"
        component={Link}
        to={to}
        ref={ref}
        style={{
          marginRight: 'auto',
          padding: '9px 16px 6px 10px',
          backgroundColor: '#243565',
          borderRadius: '100px',
          color: '#fff',
          fontSize: '14px',
          lineHeight: '1'
        }}
      >
        <ButtonIcon>
          <AddCircleOutlineIcon style={{ color: '#fff' }} />
        </ButtonIcon>
        {label}
      </Button>
    );
  })
);

const ButtonIcon = styled.span`
  display: inline-block;
  margin-right: 4px;
`;

export default NewBigButton;
